module.exports = __webpack_public_path__ + "img/result-type-wrapper-cloud.7d018a35.png";